/**
 * Configuration for inactivity timeout across the application
 * 
 * Adjust these values based on your security requirements:
 * - Higher security environments: shorter timeout (e.g., 15 minutes)
 * - Standard environments: moderate timeout (e.g., 30 minutes)
 * - Low-risk environments: longer timeout (e.g., 60 minutes)
 */

export const INACTIVITY_CONFIG = {
  // Total minutes of inactivity before automatic sign out
  TIMEOUT_MINUTES: 30,
  
  // Minutes before timeout to show warning to user
  WARNING_MINUTES: 5,
  
  // Enable/disable inactivity timeout globally
  ENABLED: true,
  
  // Activities that count as "user activity" and reset the timer
  ACTIVITY_EVENTS: [
    'mousedown',
    'mousemove',
    'keypress',
    'scroll',
    'touchstart',
    'click',
    'wheel'
  ],
  
  // Throttle interval (ms) - prevents excessive timer resets
  // Lower value = more responsive but more CPU usage
  // Higher value = less responsive but better performance
  THROTTLE_INTERVAL_MS: 1000,
  
  // Show console logs for debugging (disable in production)
  DEBUG_LOGGING: true
} as const;

/**
 * Get the timeout configuration for different user roles
 * You can customize timeouts based on user roles for enhanced security
 */
export const getTimeoutForRole = (role?: string): number => {
  switch (role) {
    case 'admin':
      return 20; // Admins get shorter timeout (20 minutes)
    case 'vss':
      return 30; // VSS users get standard timeout (30 minutes)
    case 'netzoom':
      return 30; // NetZoom users get standard timeout (30 minutes)
    default:
      return INACTIVITY_CONFIG.TIMEOUT_MINUTES;
  }
};

/**
 * Get warning time for different user roles
 */
export const getWarningTimeForRole = (role?: string): number => {
  // Admin gets 3 minute warning, others get 5 minute warning
  return role === 'admin' ? 3 : INACTIVITY_CONFIG.WARNING_MINUTES;
};
